import "./InvitePeoplePage.scss"

import { Banner, Button, Input, TextTag as Text } from "../../atoms"
import {
  CHANGE_EMAIL_BUTTON,
  INTERVAL_TIME,
  INVITE_EMAIL_TAB,
  INVITE_LABEL,
  INVITE_PHONE_TAB,
  NICKNAME_LABEL,
  NICKNAME_PLACEHOLDER,
  INVITE_FOOTER_TEXT,
  NICKNAME_REQUIRED,
} from "../../constants/messages"
import { Form, Tabs } from "antd"
import React, { useEffect, useState } from "react"
import { emailVerification, getUserData } from "../../redux/actionCreators/auth"
import {
  inviteByEmail,
  inviteByPhone,
  resetInvite,
} from "../../redux/actionCreators/invitePeople"
import {
  resendVerificationButton,
  verifyEmailAddressMessage,
  verifyEmailMessage,
} from "../../constants/validationMessages"

import InviteWithEmail from "../../components/InviteWithEmail/InviteWithEmail"
import InviteWithPhone from "../../components/InviteWithPhone/InviteWithPhone"
import _ from "../../utils/lodashUtils"
import { connect } from "react-redux"
import { useInterval } from "common-custom-hooks"
import { withRouter } from "react-router-dom"
import { NICK_NAME_MAX_LENGTH } from "../../components/PhoneInput/constants"

const { TabPane } = Tabs

const InvitePeoplePage = props => {
  const [nickName, setNickName] = useState(_.get(props.invite, "nickName", ""))
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [nickNameError, setNickNameError] = useState("")

  const signUpMethod = _.get(props.user, "signup_method")
  const isEmailVerified = _.get(props.user, "email_verification_status")

  const {
    user,
    isInvited,
    inviteByEmail,
    inviteByPhone,
    resetInvite,
    emailVerification,
    getUserData,
    inviteOperationLoading,
  } = props

  useEffect(() => {
    if (!_.get(props.invite, "nickName")) setNickName("")
  }, [props.invite.nickName])

  const invite = (type, value, nickName) => {
    const isResendingInvite = isInvited ? true : false
    // inviteByEmail and inviteByPhone thrown error is handled in child component
    if (type == "EMAIL") {
      return inviteByEmail(value, nickName, isResendingInvite)
    } else {
      return inviteByPhone(value, nickName, isResendingInvite)
    }
  }
  const handleSelect = index => {
    setSelectedIndex(index)
  }

  const resendEmail = async () => {
    const token = localStorage.getItem("token")
    await emailVerification(token)
  }

  const changeEmail = () => {
    //if primary signup is not yet verifed, we can change the primary signup
    const location = {
      pathname: "/contact",
      state: { fromLogin: false },
    }
    localStorage.removeItem("isPathFromLogin")
    props.history.push(location)
  }

  useInterval(() => {
    if (signUpMethod === "EMAIL" && !isEmailVerified) {
      props.getUserData(props.user.id)
    }
  }, INTERVAL_TIME)

  const onNickNameInputBlur = () => {
    if (!nickName) {
      setNickNameError(NICKNAME_REQUIRED)
    } else {
      setNickNameError("")
    }
  }

  const onNickNameInputChange = e => {
    setNickName(e.target.value)
    if (e.target.value && nickNameError) {
      setNickNameError("")
    }
  }

  return (
    <div id="InvitePeoplePage">
      <div className="invite-people-container">
        {signUpMethod === "EMAIL" && !isEmailVerified ? (
          <Banner type="secondary">
            <div className="resend-email-container">
              <div>
                <Text textType="sectionHeading" className="email-text">
                  {verifyEmailMessage}
                </Text>
                <br />
                <span>
                  <Text textType="sectionTextPrimary" className="verify-email">
                    {verifyEmailAddressMessage}
                  </Text>
                </span>
              </div>
              <div className="btn-container">
                <Button className="resend-email-button" onClick={resendEmail}>
                  {resendVerificationButton}
                </Button>
                <Button className="change-email-button" onClick={changeEmail}>
                  {CHANGE_EMAIL_BUTTON}
                </Button>
              </div>
            </div>
          </Banner>
        ) : null}
        <div id="HeadingWrapper">
          <div className="container-heading">
            <Text textType="pageHeading">{INVITE_LABEL}</Text>
          </div>
          <div className="sub-content">
            <Text textType="default">{INVITE_FOOTER_TEXT}</Text>
          </div>
        </div>

        <div className="container">
          <Tabs defaultActiveKey={selectedIndex} onChange={handleSelect}>
            <TabPane tab={INVITE_EMAIL_TAB} key="0">
              <div>
                <div className="nickname">
                  <Form.Item>
                    <Text className="invite-label">{NICKNAME_LABEL}</Text>
                    <Input
                      value={nickName}
                      onChange={onNickNameInputChange}
                      placeholder={NICKNAME_PLACEHOLDER}
                      autoComplete="off"
                      disabled={
                        (signUpMethod === "EMAIL" && !isEmailVerified) ||
                        isInvited
                      }
                      error={nickNameError}
                      required
                      maxLength={NICK_NAME_MAX_LENGTH}
                      onBlur={onNickNameInputBlur}
                    />
                  </Form.Item>
                </div>
                <InviteWithEmail
                  nickName={nickName ? nickName : ""}
                  setNickNameError={setNickNameError}
                  isInvited={isInvited}
                  user={user}
                  invite={invite}
                  inviteeEmail={
                    props.invite.invitationType === "EMAIL"
                      ? props.invite.partnerContact
                      : ""
                  }
                  inviteOperationLoading={inviteOperationLoading}
                  isDisabled={signUpMethod === "EMAIL" && !isEmailVerified}
                />
              </div>
            </TabPane>
            <TabPane tab={INVITE_PHONE_TAB} key="1">
              <div>
                <div className="nickname">
                  <Form.Item>
                    <Text className="invite-label">{NICKNAME_LABEL}</Text>
                    <Input
                      value={nickName}
                      onChange={onNickNameInputChange}
                      placeholder={NICKNAME_PLACEHOLDER}
                      autoComplete="off"
                      disabled={
                        (signUpMethod === "EMAIL" && !isEmailVerified) ||
                        isInvited
                      }
                      error={nickNameError}
                      onBlur={onNickNameInputBlur}
                      maxLength={NICK_NAME_MAX_LENGTH}
                      required
                    />
                  </Form.Item>
                </div>
                <InviteWithPhone
                  nickName={nickName ? nickName : ""}
                  setNickNameError={setNickNameError}
                  isInvited={isInvited}
                  user={user}
                  invite={invite}
                  inviteeMobile={
                    props.invite.invitationType === "PHONE"
                      ? props.invite.partnerContact
                      : ""
                  }
                  inviteOperationLoading={inviteOperationLoading}
                  isDisabled={signUpMethod === "EMAIL" && !isEmailVerified}
                />
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  invite: state.invitePeople,
  isInvited: state.invitePeople.isInvited,
  user: state.auth.user,
  inviteOperationLoading: state.loadingState.inviteOperationLoading,
})

export default withRouter(
  connect(mapStateToProps, {
    inviteByPhone,
    inviteByEmail,
    resetInvite,
    emailVerification,
    getUserData,
  })(InvitePeoplePage)
)
